import { customIdSchema } from './ids'
import { z } from 'zod'

export type PrescreenResident = ExternalPrescreenIndividual & {
  prescreenDate: number
  decision: PrescreenDecision
}

export const PRESCREEN_DECISIONS = ['PASS', 'FAIL', 'NO_HIT'] as const
export const PrescreenDecisionSchema = z.enum(PRESCREEN_DECISIONS)

export type PrescreenDecision = (typeof PRESCREEN_DECISIONS)[number]

/**  Si: + (md5 27 char hash of locationId + resident firstName + resident lastName) */
export const PrescreenIndividualIdSchema = customIdSchema('Si', ':')
export type PrescreenIndividualId = z.infer<typeof PrescreenIndividualIdSchema>

type SunrunRepId = `SR${string}`
export type ExternalPrescreenInput = {
  salesRepId: SunrunRepId
  contact: ExternalPrescreenIndividual & ExternalPrescreenAddress
}

export type ExternalPrescreenIndividual = {
  individualId: PrescreenIndividualId
  firstName: string
  lastName: string
  birthDate?: string
}

export type ExternalPrescreenAddress = {
  city: string
  state: string
  street: string
  zipCode: string
}

export type ExternalPrescreenResponse = {
  statusCode: number
  body: {
    individualId: PrescreenIndividualId
    decision?: PrescreenDecision
  }
}
